<template>
  <div class="about">
    <section class="section container">
      <h1 class="is-size-2-touch page-header">About Athena</h1>
      <div class="columns" id="about-top">
        <div class="column is-one-third">
          <img
            src="../assets/images/athena_statue.jpg"
            alt="Athena | Goddess of Wisdom and Strategic Warfare"
            width="100%"
          />
        </div>
        <div class="column">
          <div class="column box about-text">
            <p>
              “Athena” is the Greek goddess of wisdom, strategic warfare and
              heroics. In Athena, we believe that to win in today’s marketplace,
              you need to possess a keen strategic thought process as well as a
              lot of heroism. We provide you with the necessary strategic
              support.
            </p>
            <p>
              Founded in 2009, Athena is an emerging Management Consulting
              company, with a focus in Strategic Human Capital Development. Our
              clients come from around the world and belong to a wide variety of
              industries. We design human capital management processes, acquire
              talent, and develop human resources using intensive learning &
              development initiatives. Our goal is to provide the full spectrum
              of HR services, including executive search, staffing, learning &
              development, employee leasing services and HR process consulting
              to clients both in India and overseas.
            </p>
            <p>
              We provide excellent opportunities for candidates in India and
              overseas. We have strong capability in international placements
              and possess a deep understanding of the cultural sensitivities of
              clients and candidates alike. Our experienced set of trainers
              provide cutting-edge learning experiences and sustainable
              development modules.
            </p>
            <p>
              <b>Our Vision:</b>
              to grow into a total Management Solutions company driven by
              ethics, value and integrity.
            </p>
            <p>
              <b>Our Mission:</b>
              to assist our clients to make informed strategic decisions for the
              creation, development and sustenance of winning teams.
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-third">
          <img
            src="../assets/images/partha_profile.jpg"
            alt="Partha Raut | Founder of Athena Consulting"
          />
        </div>
        <div class="column">
          <div class="box about-text">
            <h3>Partha S. Raut</h3>
            <p>
              Athena Consulting has been conceptualized and founded by Dr.
              Partha S. Raut.
            </p>
            <p>
              Partha did his HR Management program at XISS Ranchi in 1989. He
              has also completed a Ph.D. in Management Studies. For over 28
              years he served in the HR & Strategic Management function at the
              senior-most levels at wide range of Indian and multi-national
              corporations like Bata, Castrol, the UB Group, Indian Hotels, AFL,
              IL&FS, Pratibha Industries, the Future Group, Leighton Asia etc.
              in India and abroad.
            </p>
            <p>
              Partha is a passionate Management Development professional and
              Teacher in the area of Human capital, trained by the Tata
              Management Training Centre as a professional trainer.
            </p>
            <p>
              Currently, Partha is a retained HR consultant & advisor to several
              business houses. He is also a faculty at several reputed Business
              Schools under Mumbai University and ace recruiter and a renowned
              Corporate Trainer.
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-third">
          <img src="../assets/images/rijul_profile.jpg" alt="Rijul Raut" />
        </div>
        <div class="column">
          <div class="box about-text">
            <h3>Rijul Raut</h3>
            <p>
              Since doing his B.Tech in Computer science in 2016, Rijul has
              worked as a software professional, working on creating products in
              the E-Commerce, Ed Tech and Regulatory Tech sectors.
            </p>
            <p>
              Rijul was the co-founder of an e-commerce startup named GigCult
              between 2016 to 2019, taking on the technical lead role as well as
              business functions.
            </p>
            <p>
              He has a passion for both the business and technical sides of the
              IT sector, constantly keeping himself up to date with the latest
              technologies. During his career as an entrepreneur as well as a
              Tech Leader, Rijul has been extensively involved in Talent
              acquisition in the Tech functions.
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-third"></div>
        <div class="column">
          <div class="column box about-text">
            <h3>The Team</h3>
            <p>
              Team Athena also consists of young management and software
              professionals with relevant industry and consulting experience
              along with several associates across India and the Middle East. We
              also operate in strategic alliance with a substantial number of
              eminent independent consultants.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "about",
  components: {},
};
</script>
